import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import EventIcon from "./EventIcon";
import { WithdrawalDetails } from "../../../types";
import { formatDate } from "../../../utils/formatDate";
import CardText from "../../CardText";
import StatusLabel from "../../StatusLabel";
import TransactionCard from "../../TransactionCard";

type Props = {
  status: WithdrawalDetails["status"];
};

export default function StatusCard({ status }: Props) {
  const tailwind = useTailwind();

  const { statusLabel, events } = status;

  if (!events.length) {
    return null;
  }

  return (
    <TransactionCard>
      <View style={tailwind("flex-row justify-between mb-2")}>
        <CardText.Title text="Estado de depósito" />
        <StatusLabel {...statusLabel} />
      </View>

      {/* TODO: style vertical lines between icons */}
      {events.map((event, index) => (
        <View key={index} style={tailwind("flex-row items-center mt-2")}>
          <EventIcon status={event.status} />
          <View style={tailwind("ml-4")}>
            <CardText.Subtitle
              text={formatDate(event.timestamp) || event.timestamp}
            />
            <CardText.Body text={event.text} />
          </View>
        </View>
      ))}
    </TransactionCard>
  );
}
